"use client";

import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Button } from "@/components/ui/button";
import client from "@/lib/api/client";
import { activeCtx } from "@/lib/api/state";
import { useLayout } from "@/lib/context/layout";

export const RegionSelection = () => {
    const {
        activeContext,
        setActiveContext,
        refreshDashboards,
        setRefreshDashboards,
        setRegionChange,
        userState,
    } = useLayout();
    const [state, setState] = useState<string | undefined>(Cookies.get("region"));
    const [data, setData] = useState<string[]>([]);

    useEffect(() => {
        if (!data.length) {
            client.get_regions().then((response: string[]) => {
                if (response && response.length > 0) {
                    const responseElement = response[0];
                    if (!state || !response.includes(state)) {
                        activeCtx.region = responseElement;
                        Cookies.set("region", responseElement);
                        setState(responseElement);
                    }
                }
                setData(response);
            });
        }
    }, []);

    if (userState.permissions.length === 0) {
        return <></>;
    }
    if (activeContext && (activeContext.properties as Record<string, { value: string }>)?.select_region_permission) {
        if (
            !userState.permissions.includes(
                (activeContext.properties as Record<string, { value: string }>).select_region_permission.value
            )
        ) {
            return <></>;
        }
    }

    return (
        <div className="flex items-center gap-1 rounded-lg border border-border p-0.5">
            {data.map((r) => (
                <Button
                    key={r}
                    variant={state === r ? "default" : "ghost"}
                    size="sm"
                    className="h-7 px-2 text-xs"
                    onClick={() => {
                        setState(r);
                        activeCtx.region = r;
                        setActiveContext({ ...activeContext });
                        setRefreshDashboards(!refreshDashboards);
                        setRegionChange((old) => !old);
                        Cookies.set("region", r);
                    }}
                >
                    {r}
                </Button>
            ))}
        </div>
    );
};
